import React, { useContext } from "react";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from "recharts";
import { Segment, Dropdown, Container } from "semantic-ui-react";
import { RootStoreContext } from "../../../app/stores/rootStore";
import { filterGraphicsOptions } from "../../../app/util/graphicsOptions";
import { observer } from "mobx-react-lite";
import LoadingComponent from "../../../app/layout/LoadingComponent";

let data = [{ name: "total", value: 0 }];
const COLORS = ["#0088FE", "#00C49F", "#FF8042","#A63EEB","#FF3D67","#7DDE3B","#0096C7"];
let total = 0;
const RADIAN = Math.PI / 180;
const renderLabel = (entry) => {
  const radius =
    entry.innerRadius + (entry.outerRadius - entry.innerRadius) * 0.5;
  const x = entry.cx + radius * Math.cos(-entry.midAngle * RADIAN);
  const y = entry.cy + radius * Math.sin(-entry.midAngle * RADIAN);
  return (
    (
      <g>
        <text
          x={entry.cx}
          y={entry.cy}
          dy={8}
          textAnchor="middle"
          fill="ffff"
          fontSize={25}
        >
          {total}
        </text>
        <text
          x={x}
          y={y}
          fill="white"
          textAnchor={x > entry.cx ? "start" : "end"}
          dominantBaseline="central"
        >
          {entry.value !== 0 ? entry.value: ''}
        </text>
      </g>
    )
  );
};

const SuccessfulDian: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const {
    countAcceptDian,
    acceptDian,
    valueFilterAccept,
    filterSwitch,
    loadAcceptDian,
  } = rootStore.dashboardStore;

  data = acceptDian;
  total = countAcceptDian;

  return (
    <Segment clearing>
      <div>
        <div className="graphictitle">
        <p>Envíos exitosos a la Dian</p>
        </div>
        <div className="graphicfilter">
        
        <Dropdown
          selection
          className="floatright"
          options={filterGraphicsOptions}
          onChange={(e, data) => filterSwitch(data.value, true)}
          defaultValue={valueFilterAccept}
        />
        </div>
      </div>
      
      {!loadAcceptDian ? (
        <LoadingComponent content="Cargando" />
      ) : total === 0 ? (
        <Container textAlign="center">
          <div className="graphicontent">
          <p className="zerolabelstyle">Sin información disponible</p>
          </div>          
        </Container>
      ) : (
        <div className="graphicontwithoutpadd">
        <ResponsiveContainer minHeight={250} minWidth={100}>
          <PieChart>
            <Tooltip cursor={false} />
            <Legend verticalAlign="bottom" />
            <Pie
              data={data}
              innerRadius={50}
              labelLine={false}
              label={renderLabel}
              dataKey="value"
            >
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        </div>
      )}
    </Segment>
  );
};
export default observer(SuccessfulDian);
